import Actions from '../../odata/actions';

const actions = new Actions('saltBin', 'saltBins');

export default actions;
